import { baseApi } from "./baseApi";

const COUNTRY_BASE_URL = "/countries";

export const countryApi = baseApi.injectEndpoints({
  tagTypes: ["Country"],

  endpoints: (builder) => ({
    getCountries: builder.query({
      query: (params) => ({ url: COUNTRY_BASE_URL, params }),

      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({ type: "Country", _id })),
              { type: "Country", id: "LIST" },
            ]
          : [{ type: "Country", id: "LIST" }],
    }),

    getCountryDDL: builder.query({
      query: (params) => ({
        url: `${COUNTRY_BASE_URL}/ddl`,
        params,
      }),

      providesTags: (result) =>
        result
          ? [
              ...result?.map(({ _id }) => ({ type: "Country", _id })),
              { type: "Country", id: "DDL" },
            ]
          : [{ type: "Country", id: "DDL" }],
    }),

    getCountryDetail: builder.query({
      query: (id) => ({ url: `${COUNTRY_BASE_URL}/${id}` }),

      providesTags: (result, error, id) => [
        { type: "Country", id },
        { type: "Country", id: "LIST" },
      ],
    }),

    updateCountry: builder.mutation({
      query: ({ _id, ...body }) => ({
        url: `${COUNTRY_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),

      invalidatesTags: (result, error, { _id }) => [
        { type: "Country", _id },
        { type: "Country", id: "LIST" },
      ],
    }),

    addCountryRegion: builder.mutation({
      query: ({ _id, ...body }) => ({
        url: `${COUNTRY_BASE_URL}/${_id}/regions`,
        method: "POST",
        body,
      }),

      invalidatesTags: (result, error, { _id }) => [
        { type: "Country", _id },
        { type: "Country", id: "LIST" },
      ],
    }),

    updateCountryRegion: builder.mutation({
      query: ({ _id, regionId, ...body }) => ({
        url: `${COUNTRY_BASE_URL}/${_id}/regions/${regionId}`,
        method: "PUT",
        body,
      }),

      invalidatesTags: (result, error, { _id }) => [
        { type: "Country", _id },
        { type: "Country", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useGetCountriesQuery,
  useLazyGetCountriesQuery,

  useGetCountryDDLQuery,
  useLazyGetCountryDDLQuery,

  useGetCountryDetailQuery,

  useUpdateCountryMutation,

  useAddCountryRegionMutation,
  useUpdateCountryRegionMutation,
} = countryApi;
